// src/firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, CustomProvider } from "firebase/app-check";
import { getAnalytics, isSupported } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBXmzm3AUjfIxc4qWtv20Ql5Q29owXRnRI",

  authDomain: "nextainsight.com",

  projectId: "nextainsight-eu",

  storageBucket: "nextainsight-eu.firebasestorage.app",

  messagingSenderId: "893528807773",

  appId: "1:893528807773:web:a54332b79d5be75fb830b4",
  measurementId: "G-BMXPL8GE6H",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig); // Export the app instance

// Initialize other Firebase services
const auth = getAuth(app);
const db = getFirestore(app);
const functions = getFunctions(app, "europe-west2");
const storage = getStorage(app); // Initialize Storage

const isEmulator = window.location.hostname === "localhost";

let appCheck;

if (isEmulator) {
  // Local development — connect to Firebase Emulators
  console.log("Connecting to Firebase Emulators...");
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectFirestoreEmulator(db, "127.0.0.1", 8080);
  connectFunctionsEmulator(functions, "127.0.0.1", 5001);
  connectStorageEmulator(storage, "127.0.0.1", 9199);

  // App Check with fake token for emulator (no network call needed)
  appCheck = initializeAppCheck(app, {
    provider: new CustomProvider({
      getToken: () => Promise.resolve({ token: "emulator-debug-token", expireTimeMillis: Date.now() + 3600000 }),
    }),
    isTokenAutoRefreshEnabled: false,
  });
} else {
  // Production — initialize App Check
  appCheck = initializeAppCheck(app, {
    provider: new ReCaptchaEnterpriseProvider("6LcenWYsAAAAABEpbadF6Mb3aVmCZt3nIUpv6_jx"),
    isTokenAutoRefreshEnabled: true,
  });
}

// Initialize Analytics in production only
let analytics = null;
if (!isEmulator) {
  isSupported().then((supported) => {
    if (supported) {
      analytics = getAnalytics(app);
    }
  });
}

// Export all services
export { auth, db, functions, storage, appCheck, analytics };
